import { render } from "./ProjectCancelAttachmentOffcanvas.vue?vue&type=template&id=f2da5818&scoped=true&ts=true"
import script from "./ProjectCancelAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectCancelAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectCancelAttachmentOffcanvas.scss?vue&type=style&index=0&id=f2da5818&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2da5818"]])

export default __exports__